import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import Testimonial from './Testimonial';

const Container = styled.div`
  margin-top: 24px;
`;

const testimonials = [
  {
    name: 'Birthe',
    company: 'Wonder The World',
    link: 'https://wandering.world/blog/',
    text: 'We’re very satisfied with our affiliate partnership with TakeMeTour. Nat, Third and their colleagues are always very responsive and helpful. We hope to continue working with them for years to come!',
    image: '01-birthe.jpg',
  },
  {
    name: 'Eloise',
    company: 'My Favourite Escapes',
    link: 'https://www.myfavouriteescapes.com/',
    text: "I am very impressed by the professionalism of the TakeMeTour team. I always receive my payments with no delay, and they don't make me wait to reach a minimum amount. I like recommending their tours because I loved the one I took. I appreciate how they support local people and their efforts to promote places less visited.",
    image: '02-eloise.jpg',
  },
  {
    name: 'Kestutis',
    company: 'Thai.it',
    link: 'https://www.thai.lt/',
    text: 'Whenever we are asked to recommend a reliable tour guide in Thailand, we know that we can always count on TakeMeTour team.',
    image: '03-kestutis.png',
  },
  {
    name: 'Rob & Nat',
    company: 'Love and Road',
    link: 'https://loveandroad.com/',
    text: "We love TakeMeTour products and the affiliate program. It's super easy to implement the links, the dashboard is intuitive and the payment is always on time. It's a great option to increase our revenue.",
    image: '04-rob.jpg',
  },
];

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  function decrement() {
    setIdx(oldIdx => {
      return oldIdx === 0
        ? testimonials.length - 1
        : oldIdx - 1;
    });
  }
  function increment() {
    setIdx(oldIdx => {
      return oldIdx === testimonials.length - 1
        ? 0
        : oldIdx + 1;
    });
  }
  useEffect(() => {
    const interval = setInterval(() => {
      increment();
    }, 6000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <Container>
      <Testimonial
        onLeftClick={decrement}
        onRightClick={increment}
        data={testimonials[idx]}
      />
    </Container>
  );
};

export default Testimonials;
